module.exports = __webpack_public_path__ + "media/dashboard/assets/images/partnerships-image-9f58bf3fc054580af2f3e3defe6fac4c.png";